import cloneDeep from 'lodash/cloneDeep'
import { AccountTypes } from '@/constants/user/accountTypes'
import File from '@/models-ts/File'
import Avatar from '@/models-ts/user/Avatar'

export default class AiTalentRecommendation {
  id: number
  bio: string
  type: AccountTypes
  name: string
  avgReputation: number
  avgReviews: number
  reviewsCount: number
  avatar: Avatar
  cv: Array<File>

  constructor(data: Partial<AiTalentRecommendation>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.AIRecommendedTalent) {
    return new AiTalentRecommendation({
      id: data.relations.Freelancer.id,
      bio: data.relations.Freelancer.profile?.bio || data.bio,
      type: data.relations.Freelancer.type,
      name: data.relations.Freelancer.name,
      avgReputation: data.relations.Freelancer?.profile?.avg_reputation,
      avgReviews: data.relations.Freelancer?.profile?.avg_reviews,
      reviewsCount: data.relations.Freelancer?.reviews_count,
      avatar: Avatar.fromServer(data.relations.Freelancer?.avatar),
      cv: (data.relations.Cv || []).map(File.fromServer),
    })
  }
}
